import { Clock, ShieldCheck } from "lucide-react";

interface LastUpdatedProps {
  /** ISO date of the last real editorial review. Required — do NOT bump on every build. */
  date: string;
  reviewer?: string;
  className?: string;
}

const LastUpdated = ({
  date,
  reviewer = "deepseek.ai editorial desk",
  className = "",
}: LastUpdatedProps) => {
  const display = new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div
      className={`inline-flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground ${className}`}
    >
      <span className="inline-flex items-center gap-1">
        <Clock className="h-3.5 w-3.5" />
        Last verified: <strong className="text-foreground">{display}</strong>
      </span>
      <span className="inline-flex items-center gap-1">
        <ShieldCheck className="h-3.5 w-3.5 text-primary" />
        Reviewed by {reviewer}
      </span>
    </div>
  );
};

export default LastUpdated;
